import { Component, OnInit } from '@angular/core';
import { Course, CourseService } from 'src/app/core/http/course/course.service';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';


@Component({
  selector: 'app-adm-courses',
  templateUrl: './adm-courses.component.html',
  styleUrls: ['./adm-courses.component.css']
})
export class AdmCoursesComponent implements OnInit {
  courses: Course[];
  selectedFile: File;
  fileJson: Object;
  CourseForm = new FormGroup({
    name: new FormControl(''),
    description: new FormControl(''),
    stars: new FormControl(''),
    tags: new FormControl(''),
  });
  enableEdit = false;
  enableEditIndex = null;
  enableAdd= false;
  checked = true;
  constructor(private CourseService: CourseService, private _fb: FormBuilder) { }

  ngOnInit(): void {
    this.getCourses();
  }

  getCourses() {
    this.CourseService.getAllByGroup()
    .subscribe(resp => {
      this.courses = resp;
    });
  }

  openEditForm(i, course) {
    this.enableEdit = true;
    this.enableAdd = false;
    this.enableEditIndex = i;
    this.CourseForm = this._fb.group({
      name: [course.name],
      subname: [course.subname],
      description: [course.description],
      stars: [course.stars],
      tags: [course.tags],
    });
  }
  openAddForm() {
    this.enableEdit = false;
    this.enableAdd = true;
    this.CourseForm.reset();
  }

  SaveEdit(id, i) {
    var EditedCourse:Course;
    EditedCourse = this.CourseForm.value;
    EditedCourse.id = id;
    this.CourseService.EditCourse(id, this.CourseForm.value)
    .subscribe(resp=> {
      console.log(resp);
      this.courses[i]=EditedCourse;
      this.enableEdit = false;
      this.enableEditIndex = null;
    });
  }

  AddCourse() {
    this.CourseService.AddCourse(this.CourseForm.value)
    .subscribe(resp=> {
      this.courses.push(resp);
    });
    this.enableAdd = false;
  }

  deleteCourse(id:string, i) {
    this.CourseService.DeleteCourse(id)
    .subscribe(resp=>{
      if (i !== -1) {
        this.courses.splice(i, 1);
      } 
    })
     
  }
  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    const fileReader = new FileReader();
    fileReader.readAsText(this.selectedFile, "UTF-8");
    fileReader.onload = () => {
     this.fileJson = JSON.parse(<string>fileReader.result);
     this.onUpload();
    }
    fileReader.onerror = (error) => {
      console.log(error);
    }
  }
  onUpload() {
    if (this.fileJson) {
      this.CourseService.AddCourseByFile(this.fileJson)
      .subscribe(resp=> {
        this.courses.push(resp);
        this.fileJson=null;
      })
    } else {
      console.log('Файл не загружен');
    }
  }
  changePrivate(id) {
    this.CourseService.ChangePrivate(id)
    .subscribe();
  }
}
